import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoGeneralContent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 144,
	height: 107,
	viewBox: "0 0 144 107",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M71.15 105.541C99.15 105.541 121.85 82.8409 121.85 54.7409C121.85 26.6409 99.05 3.94092 71.15 3.94092C43.15 3.94092 20.45 26.6409 20.45 54.7409C20.45 82.8409 43.15 105.541 71.15 105.541Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			style: { opacity: .7 }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.15 21.3408C24.6964 21.3408 25.95 20.0872 25.95 18.5408C25.95 16.9944 24.6964 15.7408 23.15 15.7408C21.6036 15.7408 20.35 16.9944 20.35 18.5408C20.35 20.0872 21.6036 21.3408 23.15 21.3408Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04998 75.3409C8.92186 75.3409 11.25 73.0128 11.25 70.1409C11.25 67.269 8.92186 64.9409 6.04998 64.9409C3.17809 64.9409 0.849976 67.269 0.849976 70.1409C0.849976 73.0128 3.17809 75.3409 6.04998 75.3409Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.461 28.0579V86.8956C119.461 88.6219 118.023 90.0605 116.296 90.0605H26.8889C25.1626 90.1324 23.724 88.6938 23.724 86.9675V28.0579C23.724 26.2597 25.1626 24.8931 26.8889 24.8931H116.296C118.094 24.8931 119.461 26.3316 119.461 28.0579Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.461 28.0579V32.5894H23.724V28.0579C23.724 26.2597 25.1626 24.8931 26.8889 24.8931H116.296C118.094 24.8931 119.461 26.3316 119.461 28.0579Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.3936 55.3907C59.8635 55.3907 61.055 54.1992 61.055 52.7294C61.055 51.2595 59.8635 50.068 58.3936 50.068C56.9238 50.068 55.7323 51.2595 55.7323 52.7294C55.7323 54.1992 56.9238 55.3907 58.3936 55.3907Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.8634 55.3907C86.3332 55.3907 87.5247 54.1992 87.5247 52.7294C87.5247 51.2595 86.3332 50.068 84.8634 50.068C83.3935 50.068 82.202 51.2595 82.202 52.7294C82.202 54.1992 83.3935 55.3907 84.8634 55.3907Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.9442 72.8694H67.6005C66.3058 72.8694 65.2269 71.7904 65.2269 70.4957C65.2269 69.201 66.3058 68.1221 67.6005 68.1221H75.8723C77.167 68.1221 78.246 69.201 78.246 70.4957C78.3179 71.7904 77.239 72.8694 75.9442 72.8694Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9678 30.0718C28.5637 30.0718 29.0467 29.5887 29.0467 28.9929C29.0467 28.397 28.5637 27.9139 27.9678 27.9139C27.3719 27.9139 26.8889 28.397 26.8889 28.9929C26.8889 29.5887 27.3719 30.0718 27.9678 30.0718Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.3484 30.0718C31.9443 30.0718 32.4274 29.5887 32.4274 28.9929C32.4274 28.397 31.9443 27.9139 31.3484 27.9139C30.7526 27.9139 30.2695 28.397 30.2695 28.9929C30.2695 29.5887 30.7526 30.0718 31.3484 30.0718Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.801 30.0718C35.3969 30.0718 35.88 29.5887 35.88 28.9929C35.88 28.397 35.3969 27.9139 34.801 27.9139C34.2052 27.9139 33.7221 28.397 33.7221 28.9929C33.7221 29.5887 34.2052 30.0718 34.801 30.0718Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.577 17.2685C114.858 17.2685 114.282 16.6931 114.282 15.9738V1.51615C114.282 0.796865 114.858 0.221436 115.577 0.221436C116.296 0.221436 116.872 0.796865 116.872 1.51615V15.9738C116.872 16.6931 116.296 17.2685 115.577 17.2685Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.079 28.3455C126.079 27.6262 126.654 27.0508 127.373 27.0508H141.831C142.55 27.0508 143.126 27.6262 143.126 28.3455C143.126 29.0648 142.55 29.6402 141.831 29.6402H127.373C126.654 29.6402 126.079 29.0648 126.079 28.3455Z",
			fill: "#9FA8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.928 18.9948C124.424 18.4913 124.424 17.6282 124.928 17.1247L135.213 6.91083C135.717 6.40733 136.58 6.40733 137.084 6.91083C137.587 7.41433 137.587 8.27747 137.084 8.78097L126.87 18.9948C126.294 19.4984 125.431 19.4984 124.928 18.9948Z",
			fill: "#9FA8BA"
		})
	]
});
export { SvgNoGeneralContent as ReactComponent };
